export default (props, vars) => !vars?.['usestate1isopen']?.['state'] && 'none';
